import { EndpointBuilder } from '@reduxjs/toolkit/query';
import {
  FetchArgs,
  FetchBaseQueryError,
  FetchBaseQueryMeta
} from '@reduxjs/toolkit/query';
import { BaseQueryFn } from '@reduxjs/toolkit/query';
import { DownloadCSVResponse } from '../../types';
import { DownloadCSVRecord } from '../../types/records/download-csv';

type Params = {
  type: string;
  rest: string;
};

export const downloadDataEndpoints = (
  builder: EndpointBuilder<
    BaseQueryFn<
      string | FetchArgs,
      unknown,
      FetchBaseQueryError,
      NonNullable<unknown>,
      FetchBaseQueryMeta
    >,
    string,
    'hesApi'
  >
) => ({
  downloadCSVData: builder.query<DownloadCSVRecord, { params: Params }>({
    query: ({ params: { type, rest } }) => ({
      url: `/push-data/download-report?data_type=${type}&${rest}`,
      responseHandler: async (response) => {
        const contentType = response.headers.get('content-type');

        // If the content type is JSON, parse the response as JSON
        if (contentType?.includes('application/json')) {
          return await response.json(); // Parse and return JSON
        }

        // Otherwise, treat it as a Blob (for files like CSV)
        return await response.blob(); // Handle as Blob (binary data)
      }
    }),
    transformResponse: (
      response: Blob | DownloadCSVResponse,
      meta
    ): DownloadCSVRecord => {
      const contentType = meta?.response?.headers?.get('content-type');
      console.log(response);
      console.log(contentType);

      // Check if the content type is CSV or text, indicating a file download
      if (
        contentType?.includes('text/csv') ||
        contentType?.includes('application/octet-stream')
      ) {
        // If the response is a Blob (CSV file), return it as a csvBlob
        return { csvBlob: response as Blob };
      }

      // If it's a JSON response, handle it as DownloadCSVResponse
      if ('data' in response) {
        const downloadResponse = response as DownloadCSVResponse;
        const url = downloadResponse?.data?.records[0]?.url;
        return { url };
      }

      // If neither case matches, throw an error or handle accordingly
      throw new Error('Unexpected response format');
    }
  }),
  downloadMeterStatisticsCSVData: builder.query<DownloadCSVRecord, { params: Params }>({
      query: ({ params: { rest } }) => ({
        url: `/first-data-point/download-fdp-data?${rest}`,
        responseHandler: async (response) => {
          const contentType = response.headers.get('content-type');
  
          // If the content type is JSON, parse the response as JSON
          if (contentType?.includes('application/json')) {
            return await response.json(); // Parse and return JSON
          }
  
          // Otherwise, treat it as a Blob (for files like CSV)
          return await response.blob(); // Handle as Blob (binary data)
        }
      }),
      transformResponse: (
        response: Blob | DownloadCSVResponse,
        meta
      ): DownloadCSVRecord => {
        const contentType = meta?.response?.headers?.get('content-type');
        console.log(response);
        console.log(contentType);
  
        // Check if the content type is CSV or text, indicating a file download
        if (
          contentType?.includes('text/csv') ||
          contentType?.includes('application/octet-stream')
        ) {
          // If the response is a Blob (CSV file), return it as a csvBlob
          return { csvBlob: response as Blob };
        }
  
        // If it's a JSON response, handle it as DownloadCSVResponse
        if ('data' in response) {
          const downloadResponse = response as DownloadCSVResponse;
          const url = downloadResponse?.data?.records[0]?.url;
          return { url };
        }
  
        // If neither case matches, throw an error or handle accordingly
        throw new Error('Unexpected response format');
      }
    })
});
